import React from 'react';
import { Link } from 'react-router-dom';
type Variant = 'solid' | 'outline' | 'light' | 'outline-light';
type Size = 'sm' | 'md' | 'lg';
type ButtonProps = {
  variant?: Variant;
  size?: Size;
  to?: string;
  href?: string;
  className?: string;
  children: React.ReactNode;
} & Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'className' | 'children'>;
const base = 't-label inline-flex items-center justify-center gap-2.5 whitespace-nowrap border transition-[background-color,color,border-color] duration-200 ease-out disabled:cursor-not-allowed disabled:opacity-60';
const variants: Record<Variant, string> = {
  solid: 'border-charcoal bg-charcoal text-white hover:border-graphite hover:bg-graphite',
  outline: 'border-charcoal bg-transparent text-charcoal hover:bg-charcoal hover:text-white',
  light: 'border-cream bg-cream text-charcoal hover:border-white hover:bg-white',
  'outline-light': 'border-cream/70 bg-transparent text-cream hover:border-cream hover:bg-cream hover:text-charcoal'
};
const sizes: Record<Size, string> = {
  sm: 'h-10 px-5',
  md: 'h-12 px-7',
  lg: 'h-14 px-9'
};
export function Button({
  variant = 'solid',
  size = 'md',
  to,
  href,
  className = '',
  children,
  type = 'button',
  onClick,
  ...rest
}: ButtonProps) {
  const cls = `${base} ${variants[variant]} ${sizes[size]} ${className}`;
  const linkClick = onClick as unknown as React.MouseEventHandler<HTMLAnchorElement> | undefined;
  if (to) {
    return <Link to={to} className={cls} onClick={linkClick} data-id="element-81" data-mp="3uhyp1jo8vu9g">
        {children}
      </Link>;
  }
  if (href) {
    return <a href={href} className={cls} target="_blank" rel="noreferrer" onClick={linkClick} data-id="element-82" data-mp="3giz16e8k3jec">
        {children}
      </a>;
  }
  return <button type={type} className={cls} onClick={onClick} {...rest} data-id="element-83" data-mp="3lhimqdj8mt66">
      {children}
    </button>;
}